// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2uoKB","row":"Node_row__2SU6w","label":"Node_label__21Lca","footer":"Node_footer__bZvlF"};